import { useEffect, useRef } from "react";
import { useAssetById } from "hooks/useAssetById";
import { getAssetUrl } from "./utils";
import { useAnimationSequence } from "./useAnimationSequence";
import type { ImageElement } from "./types";

interface SlideAnimationConfig {
  totalSteps: number;
  assetId?: string;
  isActive?: boolean;
  onComplete?: () => void;
}

export const useSlideAnimation = (config: SlideAnimationConfig) => {
  const { isActive = false, onComplete, assetId, totalSteps } = config;
  const hasCalledComplete = useRef(false);

  const { data: imageAsset, isLoading } = useAssetById({
    assetId,
  });

  const imageUrl = getAssetUrl(imageAsset?.data?.path);
  const { nextStep, isStepActive, isComplete } = useAnimationSequence(
    totalSteps,
    isActive
  );

  // Notify parent when complete (once)
  useEffect(() => {
    if (isComplete && onComplete && !hasCalledComplete.current) {
      hasCalledComplete.current = true;
      onComplete();
    }
  }, [isComplete, onComplete]);

  return {
    imageAsset,
    isLoading,
    imageUrl,
    nextStep,
    isStepActive,
    isComplete,
  };
};

export const useImageSlideAnimation = (
  imageElement: ImageElement | undefined,
  totalSteps: number,
  isActive: boolean,
  onComplete?: () => void
) => {
  return useSlideAnimation({
    totalSteps,
    assetId: imageElement?.asset_id,
    isActive,
    onComplete,
  });
};
